module.exports = __webpack_public_path__ + "media/components/images/flows/1-ac43da79a6fc46429c4a4577be745013.svg";